import {
  LoyaltyPointsCard,
  LoyaltyLevelCard,
  LoyaltyPointsHistory,
} from "../components";
import { Layout } from "../layouts";

const LoyaltyPage = () => {
  return (
    <Layout>
      <div className="choose_payment_method_main offer-and-reward">
        <h2 className="page-heading mb-1">Loyalty Points</h2>
        <p>Earn points on every order and enjoy exclusive rewards.</p>
        <LoyaltyPointsCard />
        <LoyaltyLevelCard />
        <LoyaltyPointsHistory />
      </div>
    </Layout>
  );
};

export default LoyaltyPage;
